module.exports = __webpack_public_path__ + "static/hero-top-sp-8142491fc215662229e82d0b5935fafb.png";